import React from 'react'
import { Outlet } from 'react-router-dom'

const Request = () => {
    return (
        <><Outlet /></>
    )
}

export default Request